import React, { Component } from 'react';
import { Log, Level, Logger } from 'ng2-logger';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../models/action/core';
import { Dispatch } from 'redux';
import Loading from '../../components/loading/loading';
import Translator from '../../core/i18n';
import * as Actions from '../../store/actions/messages';
// import { IMessagePageProps } from '../../models/pages/messages';
import Moment from 'moment';

import * as ReactDom from 'react-dom';
// import { IMessage } from '../../models/action/messages';
import { Common } from '../../core/common';
import ConversationList from './conversationList';
import ContactList from './contactList';
import ChatPanel from './chatPanel';

const T = Translator.create();
const _logger = Log.create('Message Page');
let _common: Common;

class MessagesMain extends React.Component<any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
        if (T.i18next.language === 'tr') {
            Moment.locale('tr');
        }
        if (T.i18next.language === 'en') {
            Moment.locale('en');
        }
    }
    componentDidMount() {
        const messageModuleId = 120; // message modülünün ID'si
        if (!this.props.moduleItems.includes(messageModuleId)) {
            // message modülü etkin değilse kullanıcıyı /error sayfasına yönlendir
            window.location.href  = '/almsp/u/error/';
        }
    }
    public render() {


        return (
            <div className="meesage-container col-container">
                <div className="custom-col-message-1" id="currentChatListPanel">
                    <ConversationList isMessageModelOpen={this.props.isMessageModelOpen} messageModelClosed={this.props.messageModelClosed} triggerMessageModalClosed={this.props.triggerMessageModalClosed} />
                </div>
                <div className="custom-col-message-1" id="contactListPanel" style={{display: "none"}}>
                    <ContactList />
                </div>
                <div className="custom-col-message-2" style={{ backgroundColor: 'white' }}>
           <ChatPanel isMessageModelOpen={this.props.isMessageModelOpen} messageModelClosed={this.props.messageModelClosed}  />
                </div>

            </div>


        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }

    const newProps: any = Object.assign({}, ownProps, {
        messages: state.message.messages,
        moduleItems:state.login.login.moduleItems
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch,
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.message.originMessageId === prev.message.originMessageId &&
        next.message.users === prev.message.users &&
        next.message.groupConversations === prev.message.groupConversations &&
        next.message.userConversations === prev.message.userConversations
    );
    return ret;
};

const CMessagesMain = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(MessagesMain);

export default CMessagesMain;
